import { Component, OnInit, inject } from '@angular/core';
import { ChartType } from '../../../models/ChartType';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  PreviewAnswerProperty,
  PreviewChart
} from '../../../models/previewFormResult';

interface PreviewResultModalData {
  answers: PreviewAnswerProperty[];
  charts: PreviewChart[] | null;
}

@Component({
  selector: 'wfs-preview-result-modal',
  templateUrl: './preview-result.component.html',
  standalone: false
})
export class PreviewResultModalComponent implements OnInit {
  readonly #data = inject<PreviewResultModalData>(MAT_DIALOG_DATA);
  readonly #dialogRef = inject(MatDialogRef);

  charts: PreviewChart[] = this.#data.charts ?? [];
  answers: PreviewAnswerProperty[] = this.#data.answers;
  blueBox: string = this.answers.find((answer) => answer.key === 'journalizeResult')?.value ?? '';

  lineChartLabels: string[] = [];
  labels: string[][] = [];
  series: string[][] = [];
  chartData: (number | null)[][][] = [];
  protected readonly ChartType = ChartType;

  ngOnInit(): void {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];

    this.lineChartLabels.push(formattedDate);

    this.charts.forEach((chart) => {
      const values = chart.chartKeys.map((key) => this.getAnswerValue(key));

      this.chartData.push(
        chart.type === ChartType.BarChart ? [values] : values.map((value) => [value])
      );
      this.labels.push(chart.labels ?? []);
      this.series.push(chart.type === ChartType.LineChart ? (chart.series ?? []) : (chart.labels ?? []));
    });
  }

  private getAnswerValue(key: string): number | null {
    const answer = this.answers.find((item) => item.key === key);
    return answer ? parseFloat(answer.value.replace(',', '.')) : null;
  }

  custom(index: number) {
    return index;
  }

  close(): void {
    this.#dialogRef.close();
  }
}
